"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _Stepbox = _interopRequireDefault(require("../Stepbox/Stepbox"));
var BASE_CLASS = 'csc-reset-password-confirmation';
var PasswordForgottenStepOne = function PasswordForgottenStepOne(props) {
  var title = props.title,
    titleText = props.titleText,
    titleSubHeading = props.titleSubHeading,
    stepOneTitle = props.stepOneTitle,
    stepOneDesc = props.stepOneDesc,
    stepTwoTitle = props.stepTwoTitle,
    stepTwoDesc = props.stepTwoDesc,
    stepThreeTitle = props.stepThreeTitle,
    stepThreeDesc = props.stepThreeDesc;
  var steps = [{
    name: 'Schritt',
    title: stepOneTitle,
    desc: stepOneDesc,
    active: true,
    success: false,
    icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
      size: "54",
      glyph: "icon_mail-2_54x54"
    })
  }, {
    name: 'Schritt',
    title: stepTwoTitle,
    desc: stepTwoDesc,
    active: false,
    success: false,
    icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
      size: "54",
      glyph: "icon_password_54x54"
    })
  }, {
    name: 'Schritt',
    title: stepThreeTitle,
    desc: stepThreeDesc,
    active: false,
    success: false,
    icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
      size: "54",
      glyph: "icon_user-2_54x54"
    })
  }];
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 text-center"
  }, /*#__PURE__*/_react.default.createElement("h2", null, title), /*#__PURE__*/_react.default.createElement("p", null, titleText), /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(BASE_CLASS, "__subheading")
  }, titleSubHeading)), /*#__PURE__*/_react.default.createElement(_Stepbox.default, {
    steps: steps
  }));
};
PasswordForgottenStepOne.propTypes = {
  title: _propTypes.default.string.isRequired,
  titleText: _propTypes.default.string.isRequired,
  titleSubHeading: _propTypes.default.string.isRequired,
  stepOneTitle: _propTypes.default.string,
  stepOneDesc: _propTypes.default.string,
  stepTwoTitle: _propTypes.default.string,
  stepTwoDesc: _propTypes.default.string,
  stepThreeTitle: _propTypes.default.string,
  stepThreeDesc: _propTypes.default.string
};
var _default = exports.default = PasswordForgottenStepOne;